export function Header() {
  return <header className="header">Book Club</header>;
}
